import React from 'react';
import { Link } from 'react-router';
import { useCurrentTracklog, useDebriefRouter } from 'ff/debrief/hooks';

interface Props {
    shareId: string;
    tracklogId?: string;
    onClick?: () => void;
}

const LinkToSharedDebrief = React.forwardRef<
    HTMLAnchorElement,
    React.PropsWithChildren<Props>
>(function LinkToSharedDebrief(props, ref) {
    const { shareId, ...rest } = props;
    const { tracklog } = useCurrentTracklog();
    const { getSharedDebriefRouteString } = useDebriefRouter();
    const pathString = getSharedDebriefRouteString(
        shareId || tracklog?.shareDetailsSummary?.shareId
    );
    if (pathString)
        return (
            <Link ref={ref} to={pathString} {...rest}>
                {props.children}
            </Link>
        );
    else return null;
});

export default LinkToSharedDebrief;
